<template>
  <div id="leftTabBar">
    <img id="logo" src="../../../assets/img/xinfarm_logo.svg">
    <ul>

      <li class="leftTabBarTitle" @click="toIndex" @mouseover="mouseover" @mouseout="mouseout">
        <img id="leftTabBarTitleIcon" src="../../../assets/img/mgcenter.svg"></img>
        管理中心首页
      </li>
      <li class="leftTabBarTitle" :style="activeStyle"><strong>所有管理列表</strong></li>
      <slot></slot>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "LeftTabBar",
    data(){
      return{
        isMouseover:false
      }
    },
    computed:{
      activeStyle(){
        return this.isMouseover?"cursor:pointer;color: #1389ee;":"cursor:pointer;color: #20a8d8;"
        // return !this.isActive ? {"background-color":"black"} : {};
      }
    },
    methods: {
      toIndex(){
        this.$router.push("/xsalocenter")
      },
      mouseover(){
        this.isMouseover = true
      },
      mouseout(){
        this.isMouseover = false
      },
    }
  }
</script>

<style scoped>
  #leftTabBarTitleIcon{
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
  #logo{
    padding-top: 20px;
    padding-bottom: 20px;
    width: 200px;
    height: 90px;
    background-color: black;
  }

  ul{
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
    margin-top: 0;
  }

  .leftTabBarTitle{
    padding: 0.75rem 1rem;
    color: #d1d4d7;
    line-height: 1.3125rem;
    font-size: 12px;
    font-weight: 600;
  }
</style>
